<div class="container-fluid vh-100 py-2 d-flex flex-column overflow-hidden">
  <div class="row justify-content-center flex-grow-1 overflow-hidden">
    <div class="col-12 col-md-10 col-lg-8 h-100 d-flex flex-column">
      <div class="card flex-grow-1 d-flex flex-column overflow-hidden">
        <div class="card-body d-flex flex-column overflow-hidden p-3">
          
          <div class="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
            <h1 class="fs-4 mb-0">General Terms and Conditions</h1>
            <button 
              type="button" 
              class="btn btn-outline-secondary btn-sm"
              (click)="isTermsModalOpen = true"
            >
              <span class="me-1">⛶</span> Full screen
            </button>
          </div>
          
          <div class="border p-2 mb-3 flex-grow-1 overflow-auto">
            
            <h2 class="h6 mt-2">1. Subject of the Contract</h2>
            <p class="small">
              The Landlord rents to the Tenant for a fixed term the following property:
            </p>
            <p class="small">
              <strong>Address:</strong> 1066 Dessewffy Street 3, First Floor 5.<br>
              <strong>Property type:</strong> apartment<br>
              <strong>Equipment:</strong> as described at the time of booking.
            </p>
            <p class="small">
              The Tenant is entitled to use the property for temporary accommodation purposes.
            </p>

            <h2 class="h6 mt-3">2. Rental Fee and Payment Terms</h2>
            <p class="small">
              The rental fee and costs to be paid by the Tenant correspond to the 
              amount disclosed at the time of booking.
            </p>
            <p class="small">
              The payment method is determined by the electronic payment 
              system used by the Landlord.
            </p>

            <h2 class="h6 mt-3">3. Duration of the Rental Agreement</h2>
            <p class="small">
              The contract is concluded for an indefinite period and enters into force 
              on the day of the Tenant's arrival.
            </p>
            <p class="small">
              The Tenant may terminate the agreement at any time by vacating the property. 
              The Landlord is entitled to terminate the contract immediately if the Tenant:
            </p>
            <ul class="small">
              <li>violates the house rules</li>
              <li>causes damage</li>
              <li>endangers the residential community</li>
              <li>or violates any terms of the contract</li>
            </ul>
            <p class="small">
              The contract automatically terminates when the Tenant vacates the property.
            </p>

            <h2 class="h6 mt-3">4. Security Deposit and Damages</h2>
            <p class="small">
              The Landlord is entitled to request a security deposit.
            </p>
            <p class="small">
              The Tenant is liable for:
            </p>
            <ul class="small">
              <li>damages caused to the property,</li>
              <li>damage to furnishings,</li>
              <li>loss of keys or access devices.</li>
            </ul>
            <p class="small">
              The Landlord is entitled to deduct damages from the deposit or charge separately.
            </p>

            <h2 class="h6 mt-3">5. House Rules</h2>
            <p class="small">
              The Tenant is obliged to comply with the property's house rules, which are 
              available with the booking confirmation or in the property.
            </p>
            <p class="small">
              <strong>Basic rules:</strong>
            </p>
            <ul class="small">
              <li>Smoking is prohibited in the property.</li>
              <li>Parties and events are not permitted.</li>
              <li>Noise disturbance is prohibited.</li>
              <li>The Tenant may not accommodate more persons than included in the booking.</li>
              <li>Furnishings must be used for their intended purpose.</li>
            </ul>
            <p class="small">
              Violation of the house rules results in immediate termination of the contract.
            </p>

            <h2 class="h6 mt-3">6. Check-in and Check-out</h2>
            <p class="small">
              The Tenant may take possession of the property at the pre-arranged times.
            </p>
            <p class="small">
              In case of late departure, the Landlord may charge an additional fee.
            </p>

            <h2 class="h6 mt-3">7. Liability Rules</h2>
            <p class="small">
              The Landlord is not liable for:
            </p>
            <ul class="small">
              <li>loss of the Tenant's personal belongings,</li>
              <li>damages resulting from the Tenant's fault,</li>
              <li>service interruptions due to unavoidable or external causes (power outage, internet service failure, etc.).</li>
            </ul>

            <h2 class="h6 mt-3">8. Data Processing</h2>
            <p class="small">
              The Tenant accepts that their personal data will be processed by the Landlord 
              in accordance with applicable data protection laws and state registration 
              obligations.
            </p>

            <h2 class="h6 mt-3">9. Legal Declaration and Acceptance</h2>
            <p class="small">
              The Tenant declares that:
            </p>
            <ul class="small">
              <li>they have read and understood the contract,</li>
              <li>they accept the contract electronically,</li>
              <li>they acknowledge that electronic acceptance has the same legal effect as a handwritten contract.</li>
            </ul>
          </div>

          <form (ngSubmit)="onSubmit()" #aszfForm="ngForm" class="flex-shrink-0">
            
            <div class="mb-2">
              <label for="nev" class="form-label small mb-1">
                Full name <span class="text-danger">*</span>
              </label>
              <input 
                type="text" 
                class="form-control form-control-sm" 
                id="nev" 
                name="nev"
                [(ngModel)]="name"
                required
              >
            </div>

            <div class="mb-2">
              <label for="email" class="form-label small mb-1">
                Email address
              </label>
              <input 
                type="email" 
                class="form-control form-control-sm" 
                id="email" 
                name="email"
                [(ngModel)]="email"
              >
            </div>

            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="erkezes" class="form-label small mb-1">
                  Check-in date <span class="text-danger">*</span>
                </label>
                <input 
                  type="date" 
                  class="form-control form-control-sm" 
                  id="erkezes" 
                  name="erkezes"
                  [(ngModel)]="startDate"
                  required
                >
              </div>

              <div class="col-md-6 mb-2">
                <label for="tavozas" class="form-label small mb-1">
                  Check-out date <span class="text-danger">*</span>
                </label>
                <input 
                  type="date" 
                  class="form-control form-control-sm" 
                  id="tavozas" 
                  name="tavozas"
                  [(ngModel)]="endDate"
                  required
                >
              </div>
            </div>

            <div class="mb-2">
              <div class="form-check">
                <input 
                  type="checkbox" 
                  class="form-check-input" 
                  id="elfogadva"
                  name="elfogadva"
                  [(ngModel)]="isAccepted"
                  required
                >
                <label class="form-check-label small" for="elfogadva">
                  I have read and accept the General Terms and Conditions. 
                  I acknowledge that this constitutes an electronic contract.
                  <span class="text-danger">*</span>
                </label>
              </div>
            </div>

            <div class="d-grid">
              <button 
                type="submit" 
                class="btn btn-primary"
                [disabled]="!isFormValid || isSendingInProgress"
              >
                Accept and confirm booking
              </button>
            </div>

            <p class="text-center text-muted small mt-2 mb-0">
              <span class="text-danger">*</span> Required fields
            </p>
          </form>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Fullscreen Terms Modal -->
<app-full-screen-modal 
  [isOpen]="isTermsModalOpen" 
  [title]="'General Terms and Conditions'"
  (closeModal)="isTermsModalOpen = false"
>
  <h2 class="h5 mt-2">1. Subject of the Contract</h2>
  <p>
    The Landlord rents to the Tenant for a fixed term the following property:
  </p>
  <p>
    <strong>Address:</strong> 1066 Dessewffy Street 3, First Floor 5.<br>
    <strong>Property type:</strong> apartment<br>
    <strong>Equipment:</strong> as described at the time of booking.
  </p>
  <p>
    The Tenant is entitled to use the property for temporary accommodation purposes.
  </p>

  <h2 class="h5 mt-4">2. Rental Fee and Payment Terms</h2>
  <p>
    The rental fee and costs to be paid by the Tenant correspond to the 
    amount disclosed at the time of booking.
  </p>
  <p>
    The payment method is determined by the electronic payment 
    system used by the Landlord.
  </p>

  <h2 class="h5 mt-4">3. Duration of the Rental Agreement</h2>
  <p>
    The contract is concluded for an indefinite period and enters into force 
    on the day of the Tenant's arrival.
  </p>
  <p>
    The Tenant may terminate the agreement at any time by vacating the property. 
    The Landlord is entitled to terminate the contract immediately if the Tenant:
  </p>
  <ul>
    <li>violates the house rules</li>
    <li>causes damage</li>
    <li>endangers the residential community</li>
    <li>or violates any terms of the contract</li>
  </ul>
  <p>
    The contract automatically terminates when the Tenant vacates the property.
  </p>

  <h2 class="h5 mt-4">4. Security Deposit and Damages</h2>
  <p>
    The Landlord is entitled to request a security deposit.
  </p>
  <p>
    The Tenant is liable for:
  </p>
  <ul>
    <li>damages caused to the property,</li>
    <li>damage to furnishings,</li>
    <li>loss of keys or access devices.</li>
  </ul>
  <p>
    The Landlord is entitled to deduct damages from the deposit or charge separately.
  </p>

  <h2 class="h5 mt-4">5. House Rules</h2>
  <p>
    The Tenant is obliged to comply with the property's house rules, which are 
    available with the booking confirmation or in the property.
  </p>
  <p>
    <strong>Basic rules:</strong>
  </p>
  <ul>
    <li>Smoking is prohibited in the property.</li>
    <li>Parties and events are not permitted.</li>
    <li>Noise disturbance is prohibited.</li>
    <li>The Tenant may not accommodate more persons than included in the booking.</li>
    <li>Furnishings must be used for their intended purpose.</li>
  </ul>
  <p>
    Violation of the house rules results in immediate termination of the contract.
  </p>

  <h2 class="h5 mt-4">6. Check-in and Check-out</h2>
  <p>
    The Tenant may take possession of the property at the pre-arranged times.
  </p>
  <p>
    In case of late departure, the Landlord may charge an additional fee.
  </p>

  <h2 class="h5 mt-4">7. Liability Rules</h2>
  <p>
    The Landlord is not liable for:
  </p>
  <ul>
    <li>loss of the Tenant's personal belongings,</li>
    <li>damages resulting from the Tenant's fault,</li>
    <li>service interruptions due to unavoidable or external causes (power outage, internet service failure, etc.).</li>
  </ul>

  <h2 class="h5 mt-4">8. Data Processing</h2>
  <p>
    The Tenant accepts that their personal data will be processed by the Landlord 
    in accordance with applicable data protection laws and state registration 
    obligations.
  </p>

  <h2 class="h5 mt-4">9. Legal Declaration and Acceptance</h2>
  <p>
    The Tenant declares that:
  </p>
  <ul>
    <li>they have read and understood the contract,</li>
    <li>they accept the contract electronically,</li>
    <li>they acknowledge that electronic acceptance has the same legal effect as a handwritten contract.</li>
  </ul>
</app-full-screen-modal>

<!-- Loading Modal -->
<app-loading-modal
  [isLoading]="isSendingInProgress"
  [isSuccess]="isSuccess"
  [isError]="isError"
  [loadingTitle]="'Sending confirmation...'"
  [loadingMessage]="'Please wait while we process your booking.'"
  [successTitle]="'✓ Success!'"
  [successMessage]="'Your booking has been confirmed.<br>A confirmation email has been sent.'"
  [errorTitle]="'✗ Error'"
  [errorMessage]="'An error occurred while sending.<br>Please try again later.'"
></app-loading-modal>